import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-news-overlay/jb-news-overlay.css.ts
var jb_news_overlay_css_default = i`:host{background-color:#f1f2f2;display:block;min-height:100vh}.news-overlay{opacity:0}`;

export {
  jb_news_overlay_css_default
};
